import { atom } from 'recoil';
import { syncEffect } from 'recoil-sync';
import { string, nullable } from '@recoiljs/refine';

import type Paho from 'paho-mqtt';
import { ColumnAggregationSetting } from 'views/services/types';

export const tokenState = atom<string | null | undefined>({
  key: 'tokenState',
  default: 'ss',
  effects: [
    syncEffect({
      itemKey: 'sessionToken',
      storeKey: 'general',
      refine: nullable(string()),
    }),
  ],
});

export const isShareViewState = atom({
  key: 'isShareViewState',
  default: false,
});

export const isReportingModalOpenState = atom({
  default: false,
  key: 'reporting-modal-open',
});

export const notificationsState = atom<Paho.Message | undefined>({
  key: 'notificationsState',
  default: undefined,
});

export const isIdentifierImgPreviewOpenState = atom({
  default: false,
  key: 'is-identifier-img-preview-open-state',
});

export const columnAggregationSettingsAtom = atom<ColumnAggregationSetting[]>({
  default: [],
  key: 'column-aggregation-settings',
});
